import { apiSlice } from '../../../setup/api/api.slice';

export const pushNotificationEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        pushNotificationSubscribe: builder.mutation<undefined, PushSubscriptionJSON>({
            query: request => ({
                url: 'notifications/subscribe',
                method: 'POST',
                body: request,
            }),
        }),
    }),
});
